import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterMenu } from '../../shared/models/filter-menu';
import { SortMenu } from '../../shared/models/sort-menu';
import { PanelList } from '../../shared/models/panel-list';
import { DocumentTemplateManagementConstants } from '../document-template-management-constants';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-where-am-i-used-modal',
  templateUrl: './where-am-i-used-modal.component.html',
  styleUrls: ['./where-am-i-used-modal.component.scss']
})
export class WhereAmIUsedModalComponent implements OnInit {

  @Input() isWhereAmIUsedModalShow!: boolean;
  @Input() whereAmIUsedList!:[];
  @Output() isCloseWhereAmIUsedModal = new EventEmitter<boolean>();
  readonly whereAmIUsedEmptyMessage =
    DocumentTemplateManagementConstants.WhereAmIUsed_Empty_Message;
  display:boolean=true;
  whereAmIUsedListData:any=[];
  whereAmIUsedPanelListInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: []
  };
  noData: boolean = false;

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.getwhereAmIUsedListData();
    this.whereAmIUsedPanelListInput.lists=this.whereAmIUsedListData;
    this.noData = this.commonService.IsListEmpty(this.whereAmIUsedListData);
    this.whereAmIUsedPanelListInput.filters = this.getFiltersForWhereAmIUsedList();
    this.whereAmIUsedPanelListInput.sort = this.getSortFieldsForWhereAmIUsedList();
  }

  closeWhereAmIUsedModal(){
    this.isWhereAmIUsedModalShow=false;
    this.isCloseWhereAmIUsedModal.emit(this.isWhereAmIUsedModalShow);
  }



  getwhereAmIUsedListData() {
    this.whereAmIUsedListData = []; // Clear existing data if needed
    this.whereAmIUsedList.forEach((scope: any) => {
      this.whereAmIUsedListData.push({ eQMSScope: scope.value });
    });
    // Sorting by the eQMSScope field
    this.whereAmIUsedListData.sort((a: { eQMSScope: string }, b: { eQMSScope: string }) =>
      a.eQMSScope > b.eQMSScope ? 1 : -1
    );
  }
  
  getFiltersForWhereAmIUsedList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'eQMS Scope',
        filterFieldName: 'eQMSScope',
      }
    );
    return filters;
  };
  
  getSortFieldsForWhereAmIUsedList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      { sortFieldDisplayName: 'eQMS Scope', sortFieldName: 'eQMSScope' }
    );
    return sortMenu;
  };
  
}
